import { Button } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { useTranslation } from 'react-i18next'

interface IShowHideButton {
  isHidden: boolean
  count: number
  onClick: () => void
  size?: 'small' | 'medium' | 'large'
  disabled?: boolean
  dataTestId?: string
}

const ShowHideButton = (props: IShowHideButton) => {
  const { t } = useTranslation()

  const {
    size = 'small',
    count = 0,
    isHidden,
    onClick,
    disabled = false,
    dataTestId = 'show-hide-button',
  } = props

  return (
    <Button
      size={size}
      onClick={onClick}
      color="secondary"
      disabled={disabled}
      data-testid={dataTestId}
      startIcon={isHidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
    >
      {isHidden ? t('common.showFilters') : t('common.hideFilters')}{' '}
      {count ? `(${count})` : null}
    </Button>
  )
}

export default ShowHideButton
